import { render, staticRenderFns } from "./top_page.vue?vue&type=template&id=213a874e&"
import script from "./top_page.vue?vue&type=script&lang=js&"
export * from "./top_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports